import { ArcgisMap, type ArcgisMapProps } from './ArcgisMap';
import MapLoader from './MapLoader';
import { Box, type SxProps } from '@presov.sk/presov-ui-react';
import React, { Suspense } from 'react';

type Props = ArcgisMapProps & {
  loading?: boolean;
  sx?: SxProps;
};

const GeoMap: React.FC<Props> = ({
  ref,
  onReady,
  onMove,
  onClick,
  onAction,
  disableAction,
  onPopupVisible,
  onZoom,
  onSearchResult,
  search,
  searchPosition,
  searchSlot,
  locationIndicator,
  loading,
  sx,
  hideUserLocation,
  initialLocation,
  initialZoom,
  disablePopup,
  allowSingleFingerPan,
  withoutDeviceLocation,
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: 1,
        height: 1,
        '.esri-view': {
          '--esri-view-outline': 'none !important',
        },
        ...sx,
      }}
    >
      <Suspense fallback={<MapLoader />}>
        {/* relative scope for MapLoader */}
        <ArcgisMap
          ref={ref}
          onReady={onReady}
          onMove={onMove}
          onClick={onClick}
          onAction={onAction}
          onSearchResult={onSearchResult}
          disableAction={disableAction}
          search={search}
          searchPosition={searchPosition}
          searchSlot={searchSlot}
          hideUserLocation={hideUserLocation}
          onPopupVisible={onPopupVisible}
          disablePopup={disablePopup}
          onZoom={onZoom}
          initialLocation={initialLocation}
          initialZoom={initialZoom}
          allowSingleFingerPan={allowSingleFingerPan}
          withoutDeviceLocation={withoutDeviceLocation}
          locationIndicator={locationIndicator}
        />
        {loading && <MapLoader />}
      </Suspense>
    </Box>
  );
};

export default GeoMap;
